module.exports = __webpack_public_path__ + "static/img/preview-3.d170bec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/preview/preview-3.png
// module id = ojvL
// module chunks = 35